<template>
  <confirmation-prompt
    id="expire-date-prompt"
    :show="show"
    :title="i18n.t('/expiredate/prompt/title')"
    :info-text="infoText"
    :cancel-button-text="i18n.t('/expiredate/prompt/nochange')"
    :confirm-button-show="false"
    :extra-wide="true"
    @cancel="cancelAction"
    @close="close"
  >
    <proposition-block
      ref="expireDatePropositionBlock"
      :show-delivery-date="false"
      :show-do-not-deliver-before-date="false"
      :show-expire-date="true"
    />
    <template #buttons>
      <app-button data-qa="expire-date-prompt-change-today" @click="setToToday()">
        {{ i18n.t('/expiredate/prompt/today') }}
      </app-button>
      <app-button data-qa="expire-date-prompt-change-valid-days" @click="setToValidDaysDate()">
        {{ dealerValidDateFormatted }}
      </app-button>
      <app-button
        ref="expireDateOther"
        data-qa="expire-date-prompt-change-other"
        @click="changeExpireDate(null)"
      >
        {{ i18n.t('/expiredate/prompt/other') }}
      </app-button>
    </template>
  </confirmation-prompt>
</template>

<script>
import ConfirmationPrompt from '@/components/generic/presentational/molecules/confirmationPrompt/ConfirmationPrompt.vue'
import PropositionBlock from '@/components/generic/presentational/molecules/propositionBlock/PropositionBlock.vue'
import CheckExpireDate from '@/mixins/checkExpireDate.js'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import { ref } from 'vue'

export default {
  // Use CheckExpireDate mixin with any component using this prompt
  components: {
    PropositionBlock,
    ConfirmationPrompt,
    AppButton,
  },
  mixins: [CheckExpireDate],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    currentDate: {
      type: String,
      default: null,
    },
    extraWide: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'confirm'],
  setup() {
    const expireDateOther = ref(null)
    const expireDatePropositionBlock = ref(null)

    return {
      expireDateOther,
      expireDatePropositionBlock,
    }
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      savedDate: null,
    }
  },
  computed: {
    ...mapState('user', ['dealerSettings']),
    infoText() {
      if (this.expireDateExpired()) {
        return this.i18n.te('/expiredate/prompt/infotextexpired')
          ? this.i18n.t('/expiredate/prompt/infotextexpired')
          : null
      } else {
        return this.i18n.te('/expiredate/prompt/infotextmaybeincorrect')
          ? this.i18n.t('/expiredate/prompt/infotextmaybeincorrect')
          : null
      }
    },
    dealerValidDate() {
      return moment.utc().add(this.dealerSettings.quoteValidDays, 'days').startOf('day')
    },
    dealerValidDateFormatted() {
      return this.i18n.t('/expiredate/prompt/changeto', {
        validDate: this.dealerValidDate.format('DD-MM-YYYY'),
      })
    },
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.savedDate = moment.utc(this.quoteExpireDate)
      }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    changeExpireDate(date) {
      if (!date) {
        // Change focus to button to trigger update of datepicker
        this.expireDateOther.$el.focus()
      } else {
        this.expireDatePropositionBlock.changeExpireDate(date)
      }
      this.$emit('confirm')
      this.close()
    },
    setToToday() {
      this.changeExpireDate(moment.utc().startOf('day'))
    },
    setToValidDaysDate() {
      this.changeExpireDate(this.dealerValidDate)
    },
    cancelAction() {
      this.changeExpireDate(this.savedDate)
    },
  },
}
</script>

<style></style>
